import { render, staticRenderFns } from "./NotificationsChannelSettings.vue?vue&type=template&id=16c3c8c9&scoped=true"
import script from "./NotificationsChannelSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsChannelSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsChannelSettings.vue?vue&type=style&index=0&id=16c3c8c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3c8c9",
  null
  
)

export default component.exports